export const GEAR_SHOP_MULTIPASS_PATH = '/shopify/login';
export const MEMBER_DEALS_MULTIPASS_PATH = '/shopify/member_deals_login';

export const buildGearShopUrl = (path: string, irclickid?: string) => `${path}${irclickid ? `?${new URLSearchParams({ irclickid })}` : ''}`;
